import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: (params: any) => <HoverCopyCell value={params.row.code} />,
    },
    {
        field: 'name',
        headerName: 'Tên',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => <HoverCopyCell value={params.row.name} />,
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 150,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
];
